import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeFileId: 0,
  clipTime: 0,
  originalTime: 0,
  playState: "STOP",
  volume: 100,
};

const filteredFilesSlice = createSlice({
  name: "filteredFiles",
  initialState,
  reducers: {
    reset: () => initialState,
    setActiveFilteredFiles: (state, action) => {
      if (action.payload !== null && action.payload !== undefined) {
        state.activeFileId = action.payload;
      }
    },
    setClipTimeFilteredFiles: (state, action) => {
      state.clipTime = action.payload.clipTime;
      state.originalTime = action.payload.originalTime;
    },
    setPlayStateFilteredFiles: (state, action) => {
      state.playState = action.payload;
    },
    setVolumeFilteredFiles: (state, action) => {
      state.volume = action.payload;
    },
  },
});

export const {
  reset,
  setActiveFilteredFiles,
  setClipTimeFilteredFiles,
  setPlayStateFilteredFiles,
  setVolumeFilteredFiles,
} = filteredFilesSlice.actions;

export default filteredFilesSlice.reducer;
